import { useMutation } from '@tanstack/react-query';
import signupApi from '@/features/auth/signup/api/signupApi.ts';
import { toast } from 'sonner';
import { isEmailVerificationRateLimited } from '@/features/auth/signup/utils/emailVerificationRateLimit.ts';

export default function useSendEmailVerification() {
  return useMutation({
    mutationFn: signupApi.sendEmailVerification,
    onError: (error: Error) => {
      // Stan limitu pokazuje strona weryfikacji — toast by go dublował.
      if (isEmailVerificationRateLimited(error)) return;
      toast.error('Nie udało się wysłać emaila weryfikacyjnego', {
        description: error.message,
      });
    },
  });
}
